import axios from '../../api';

export const actionLendelaHealthCheck = (payload) => async () => {
    try {
        const response = await axios.get('/lendela/health-check', payload);
        return response.data;
    } catch (error) {
        //
    }
};

export const actionLendelaVerify = (payload) => async () => {
    try {
        const response = await axios.post('/lendela/verify', payload);
        return response.data;
    } catch (error) {
        //
    }
};

export const actionLendelaAppInfo = (app_id) => async () => {
    try {
        const response = await axios.get('/lendela/application/info?app_id='+app_id);
        return response.data;
    } catch (error) {
        //
    }
};